/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import Logo from "./Logo";
import { useNavigate } from "react-router-dom";
import QuickScan from "./home/QuickScan";


const Footer = ({ className }) => {
    const navigate = useNavigate();
    const [isQuickScanOpen, setIsQuickScanOpen] = useState(false);

    return (
        <div className="bg-white border-t border-[#e4e5e7] font-['Plus_Jakarta_Sans',sans-serif]">
            {/* First row: 4 columns */}
            <div className={`max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[40px] md:py-[48px]`}>

                <div className="flex flex-col lg:flex-row gap-[32px] lg:gap-[24px] lg:items-start">
                    {/* Column 1: Logo */}
                    <div className="flex flex-col lg:flex-row gap-[32px] lg:gap-[24px] lg:items-start">
                        <div className="shrink-0 lg:w-[240px]">
                            <Logo />
                            <p className="font-medium text-[13px] text-[#9298a0] leading-[1.5] mt-[10px] max-w-[200px]">Your central marketplace for print shops &amp; suppliers.</p>
                        </div>
                    </div>

                    {/* Column 2: Information */}
                    <div className="flex flex-1 flex-col sm:flex-row gap-[28px] sm:gap-[48px] lg:gap-[40px]">
                        <div className="min-w-[140px]">
                            <p className="font-semibold text-[11px] text-[#9298a0] tracking-[0.8px] uppercase mb-[14px]">Information</p>
                            <div className="flex flex-col gap-[10px]">
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/marketplace" data-discover="true">Marketplace</a>
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/about" data-discover="true">About</a>
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/shop-login" data-discover="true">Store Login</a>
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/onboarding/plan" data-discover="true">List My Business</a>
                            </div>
                        </div>
                        <div className="min-w-[140px]">
                            <p className="font-semibold text-[11px] text-[#9298a0] tracking-[0.8px] uppercase mb-[14px]">General</p>
                            <div className="flex flex-col gap-[10px]">
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/contact" data-discover="true">Contact</a>
                                <button
                                    className="font-medium text-left text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors"
                                    onClick={() => setIsQuickScanOpen(true)}
                                >Quick Scan</button>

                            </div>
                        </div>
                        <div className="min-w-[140px]">
                            <p className="font-semibold text-[11px] text-[#9298a0] tracking-[0.8px] uppercase mb-[14px]">Policies</p>
                            <div className="flex flex-col gap-[10px]">
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/acceptable-use-policy">Acceptable Use</a>
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/shipping-policy">Shipping</a>
                                <a className="font-medium text-[14px] text-[#212326] no-underline hover:text-[#ff5323] transition-colors" href="/returns-policy">Returns &amp; Refunds</a>
                            </div>
                        </div>
                    </div>


                    {/* Column 3: Contact */}
                    <div className="flex flex-col items-start lg:items-end gap-[12px] shrink-0">
                        <button
                            onClick={() => navigate("/contact")}
                            data-discover="true"
                            className="inline-flex items-center justify-center px-[18px] py-[9px] rounded-[10px] bg-[#ff5323]
                         font-semibold text-[13px] text-white no-underline hover:bg-[#e64a1f] transition-colors"
                        >Get In Touch
                        </button>
                        <div className="flex flex-col items-start lg:items-end gap-[2px]">
                            <a href="tel:+27832511287" className="font-medium text-[13px] text-[#53585f] no-underline hover:text-[#ff5323] transition-colors">+27 (0) 83 2511 287</a>
                            <a href="mailto:shiv@signetsolutions.co.za" className="font-medium text-[13px] text-[#53585f] no-underline hover:text-[#ff5323] transition-colors">shiv@signetsolutions.co.za</a>
                        </div>
                    </div>

                </div>

                {/* Divider */}
                <div className="h-[1px] bg-[#e4e5e7] my-[28px] md:my-[36px]"></div>

                {/* Bottom row */}
                <div className={`flex flex-col-reverse sm:flex-row items-start sm:items-center justify-between gap-[16px] ${className}`}>
                    {/* Left side: Social icons */}
                    <div className="flex items-center gap-3">
                        <a
                            href="https://www.instagram.com/signetprint/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 flex items-center justify-center bg-primary text-white rounded-full hover:opacity-80"
                        >
                            <FaInstagram className="w-5 h-5" />
                        </a>
                        <a
                            href="https://www.linkedin.com/company/signetprint/about/?viewAsMember=true"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 flex items-center justify-center bg-primary text-white rounded-full hover:opacity-80"
                        >
                            <FaLinkedinIn className="w-5 h-5" />
                        </a>
                    </div>

                    {/* Right side: Address */}
                    <p className="font-medium text-[12px] text-[#9298a0] leading-[1.5] max-w-[300px] text-left sm:text-right">
                        Watershed, 17 Dock Rd, Victoria & Alfred Waterfront, Cape Town, 8002
                    </p>
                </div>

            </div>



            {isQuickScanOpen && (
                <QuickScan isQuickScanOpen={isQuickScanOpen} onClose={() => setIsQuickScanOpen(false)} />
            )}

        </div>

    );
};

export default Footer;
